export default __webpack_public_path__ + "static/media/remix-icon.19014357.svg";